import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Label, Card, CardBody, Input, Button, Spinner, FormFeedback, Form } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link, useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import PreviewCardHeader from '../../../Components/Common/PreviewCardHeader';
import { updateStep, resetStepFlag, getStepDetails } from '../../../store/actions';
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MsgToast from "../../../Components/Common/MsgToast";
import { call} from "redux-saga/effects"

const StepEdit = () => {
    document.title = "Edit Step | Defendit - Admin Panel";
    const { id } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [isCreating, setIsCreating] = useState(false);
    const { isStepUpdate, isStepUpdateFail, error, success, details } = useSelector(state => ({
        isStepUpdate: state.Steps.isStepUpdate,
        isStepUpdateFail: state.Steps.isStepUpdateFail,
        error: state.Steps.error,
        success: state.Steps.success,
        details: state.Steps.details,
    }));

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            name: (details && details.title)?details.title:'',
            description: (details && details.description)?details.description:'',
            icon: (details && details.icon)?details.icon:'',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Step Name"),
            description: Yup.string().required("Please Enter Description"),
            icon: Yup.string().required("Please Enter Icon")
        }),
        onSubmit: (values) => {
            setIsCreating(true)
            const data = {
                id: id,
                title: values.name,
                description: values.description,
                icon: values.icon
            }
            dispatch(updateStep(data))
        },
    });

    useEffect(() => {
        if(isStepUpdate || isStepUpdateFail){
            setIsCreating(false)
            setTimeout(() => {
            dispatch(resetStepFlag())
            history.push("/steps");
            }, 3000);
        }
      }, [dispatch, isStepUpdate, isStepUpdateFail, history]);

      useEffect(() => {
        dispatch(getStepDetails({id:id}))
      }, [dispatch, id]);

    return (
        <>
            <div className="page-content">
                <Container fluid={true}>
                    <BreadCrumb title="Edit Step" pageTitle="Steps" pageUrl="/steps" />
                    <Row>
                        <Form onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <Col lg={12}>
                                <Card>
                                    <PreviewCardHeader title="Edit Step" />

                                    <CardBody className="card-body">

                                        <div className="live-preview">
                                            <Row className="gy-4">

                                                <Col xxl={6} md={6}>
                                                    <div>
                                                        <Label htmlFor="placeholderInput" className="form-label">Name*</Label>
                                                        <Input
                                                            type="text"
                                                            id='placeholderInput'
                                                            className="form-control"
                                                            placeholder="Step name"
                                                            name='name'
                                                            value={validation.values.name || ""}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            validate={{
                                                                required: { value: true },
                                                            }}
                                                            invalid={
                                                                validation.touched.name && validation.errors.name ? true : false
                                                            }
                                                        />
                                                        {validation.touched.name && validation.errors.name ? (
                                                            <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col>

                                                <Col xxl={6} md={6}>
                                                    <div>
                                                        <Label htmlFor="placeholderInput" className="form-label">Icon*</Label>
                                                        <Input
                                                            type="text"
                                                            id='placeholderInput'
                                                            className="form-control"
                                                            placeholder="Icon name"
                                                            name='icon'
                                                            value={validation.values.icon || ""}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            validate={{
                                                                required: { value: true },
                                                            }}
                                                            invalid={
                                                                validation.touched.icon && validation.errors.icon ? true : false
                                                            }
                                                        />
                                                        {validation.touched.icon && validation.errors.icon ? (
                                                            <FormFeedback type="invalid">{validation.errors.icon}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col>

                                                <Col xxl={12} md={12}>
                                                    <div>
                                                        <Label htmlFor="placeholderInput" className="form-label">Description</Label>
                                                        <Input
                                                            type="textarea"
                                                            id='placeholderInput'
                                                            className="form-control"
                                                            placeholder="Description"
                                                            rows="3"
                                                            name='description'
                                                            value={validation.values.description || ""}
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            validate={{
                                                                required: { value: true },
                                                            }}
                                                            invalid={
                                                                validation.touched.description && validation.errors.description ? true : false
                                                            }
                                                        />
                                                        {validation.touched.description && validation.errors.description ? (
                                                            <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                                        ) : null}
                                                    </div>
                                                </Col>

                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div className="text-end mb-4">
                                    <Link to="/steps" className="btn btn-danger w-sm me-1">Cancel</Link>
                                    <Button color="success" className="btn-load" disabled={isCreating} type="submit">
                                        <span className="d-flex align-items-center">
                                            {isCreating && <Spinner size="sm" className="flex-shrink-0 me-2"> Update </Spinner>}
                                            <span className="flex-grow-1" >
                                                Update
                                            </span>
                                        </span>
                                    </Button>
                                </div>
                            </Col>
                        </Form>
                    </Row>
                    {isStepUpdate ? <MsgToast msg={success} color="success" icon="ri-checkbox-circle-line" />: null}
                    {isStepUpdateFail ? <MsgToast msg={error} color="danger" icon="ri-error-warning-line" /> : null}
                    <ToastContainer limit={1} closeButton={false} />
                </Container>
            </div>
        </>
    );
}

export default StepEdit;